import {
    useEffect,
    useState,
    type FC
} from "react";
import type IPieChartSliceProps from "./type";
import {
    useAnimatedState
} from "../../../../helpers/motion";
import {
    Path,
    G
} from "react-native-svg";
import {
    CHART_PATTERN_ANGLES,
    getChartArcPath
} from "../../../chart/util";

const PieChartSlice: FC<IPieChartSliceProps> = ({
    surfaceColor,
    customTheme,
    patternID,
    geometry,
    isActive,
    opacity,
    pattern,
    color,
    isRTL,
    start,
    lift,
    end,
    gap
}) => {
    const animatedValue = useAnimatedState({
        isNativeDriverEnabled: false,
        value: isActive ? 1 : 0,
        intent: "hover",
        customTheme
    });

    const [
        progress,
        setProgress
    ] = useState<number>(isActive ? 1 : 0);

    useEffect(() => {
        const listenerID = animatedValue.addListener(({
            value
        }) => {
            setProgress(value);
        });

        return () => {
            animatedValue.removeListener(listenerID);
        };
    }, [
        animatedValue
    ]);

    const mid = (start + end) / 2;

    const offset = lift * progress;

    const sign = isRTL ? -1 : 1;

    const path = getChartArcPath({
        cx: geometry.cx + sign * offset * Math.sin(mid),
        cy: geometry.cy - offset * Math.cos(mid),
        innerRadius: geometry.inner,
        outerRadius: geometry.outer,
        startAngle: start,
        endAngle: end,
        isRTL
    });

    if(!path) {
        return null;
    }

    return <G
        opacity={opacity}
    >
        <Path
            strokeLinejoin="round"
            stroke={surfaceColor}
            fillRule="evenodd"
            strokeWidth={gap}
            fill={color}
            d={path}
        />
        {
            CHART_PATTERN_ANGLES[pattern].map((angle) => <Path
                fill={`url(#${patternID}-${angle})`}
                fillRule="evenodd"
                key={angle}
                d={path}
            />)
        }
    </G>;
};
export default PieChartSlice;
